export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/enums/CartItemType.ts